<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>{{ pageTitle }}</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBackToDashboard">
            Back to Dashboard
          </button>
        </div>
      </div>
      <el-alert
        v-if="this.activeName == 'reachedout' || this.activeName == 'connected'"
        v-bind:title="pageDescription + $t('lorganization') + 's'"
        type="warning"
        :closable="false"
      ></el-alert>
      <el-alert
        v-else
        v-bind:title="pageDescription + $t('lorganization')"
        type="warning"
        :closable="false"
      ></el-alert>
      <div v-if="activeName === 'reachedout' && !showNoData">
        <el-table
          :data="tableData.filter(data => !search || data.companyName.toLowerCase().includes(search.toLowerCase()))"
          style="width: 100%">
          <el-table-column label="Role Title" prop="roleTitle"></el-table-column>
          <el-table-column label="Company" prop="companyName"></el-table-column>
          <el-table-column label="Matching Percentage" prop="matchedPercentage">
            <template scope="scope">
              <div style="margin-left: 35px;">
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="Type to search"
              />
            </template>
            <template slot-scope="scope">
              <el-button class="btn-decline" @click="handleAccept(scope.row)"
                >Accept</el-button
              >
              <el-button @click="handleDeclineConnect(scope.row)"
                >Decline</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="activeName === 'connected' && !showNoData">
        <el-table
          :data="tableData.filter(data => !search || data.companyName.toLowerCase().includes(search.toLowerCase()))"
          style="width: 100%"
          empty-text
        >
          <el-table-column 
            label="Company" 
            prop="companyName">
          </el-table-column>
          <el-table-column 
            label="Role Title" 
            prop="roleTitle">
          </el-table-column>
          <el-table-column 
            label="Status" 
            prop="employerStatusName">
          </el-table-column>
          <el-table-column label="Matching Percentage" prop="matchedPercentage">
            <template scope="scope">
              <div style="margin-left: 35px;">
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="Type to search"
              />
            </template>
            <template slot-scope="scope">
              <el-button @click="handleView(scope.row)">View Details</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="activeName === 'offersent' && !showNoData">
        <el-table
          :data="
            tableData.filter(
              (data) =>
                !search ||
                data.CompanyName.toLowerCase().includes(search.toLowerCase())
            )
          "
          style="width: 100%"
        >
          <el-table-column 
            label="Company" 
            prop="companyName">
          </el-table-column>
          <el-table-column 
            label="Role Title" 
            prop="roleTitle">
          </el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="Type to search"
              />
            </template>
            <template slot-scope="scope">
              <el-button class="btn-decline" @click="handleOffer(scope.row)"
                >Accept Offer</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="showNoData" class="no-data">
      <div>
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x"></i>
          <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
        </span>
        <div class="no-data-text">{{ noDataText }}</div>
      </div>
    </div>
    <el-dialog
      title="Accept Apprenticeship Role Matched"
      :visible="showAcceptModal"
      :show-close="false"
      width="600px"
      class="ts-modal"
    >
      <p>
        By accepting this apprenticeship role match from company <u>{{ selectedRow.companyName }}</u>, they will be 
        notified that you accepted the apprenticeship role match and will be able to see your contact information.
      </p>
      <p>
        This way, they will be able to contact you and begin the interview
        process.
      </p>
      &nbsp;&nbsp;
      <el-row :gutter="5">
        <el-col :offset="8" :xl="4" :lg="4" :md="4">
          <button class="ts-btn ts-btn-small" @click="acceptJobMatch">
            Accept
          </button>
        </el-col>
        <el-col :xl="5" :lg="5" :md="5">
          <button
            class="ts-btn ts-btn-small ts-btn-white"
            @click="onCloseAcceptDialog()"
          >
            Cancel
          </button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="Decline Invitation"
      :visible="showDeclineConnectModal"
      :show-close="false"
      width="600px"
      class="ts-modal"
    >
      <p>
        Are you sure you want to decline the invitation from company <u>{{ selectedRow.companyName }}</u>
        regarding the role match for <u>{{ selectedRow.roleTitle }}</u>?
      </p>
      &nbsp;&nbsp;
      <el-row>
        <el-col :offset="7" :xl="6" :lg="6" :md="6">
          <button
            style="width: 100px"
            class="ts-btn ts-btn-small"
            @click="declineConnect"
          >
            Yes
          </button>
        </el-col>
        <el-col :xl="6" :lg="6" :md="6">
          <button
            style="width: 100px"
            class="ts-btn ts-btn-small ts-btn-white"
            @click="onCloseDeclineConnectDialog()"
          >
            No
          </button>
        </el-col>
      </el-row>
    </el-dialog>
    <AcceptDeclineJobOffer
      :Info="selectedRow"
      :ShowModal="showAcceptApprenticeshipRoleModal"
      @accept-job-offer-modal-closed="handleAcceptJobOfferModalClosed"
      @accept-offer-success="handleAcceptOfferSuccess"
      @decline-offer-success="handleDeclineOfferSuccess"
    >
    </AcceptDeclineJobOffer>
    <RoleInfo
      :Info="selectedRow"
      :ShowModal="showRoleInfoModal"
      @role-info-closed="handleRoleInfoClosed"
      @cancel-job-match-success="handleCancelJobMatchSuccess"
      TypeLabel="Apprentice"
    >
    </RoleInfo>
    <!-- <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>
<script>
import * as signalR from "@aspnet/signalr";
import RoleInfo from "../../../../components/RoleInfo.vue";
import AcceptDeclineJobOffer from "../../../../components/AcceptDeclineJobOffer.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: {
    RoleInfo,
    AcceptDeclineJobOffer,
    TSLoading,
  },
  created() {
    this.activeName = this.$route.params.status;

    if (this.activeName === "reachedout") {
      this.activeValue = 1;
      this.pageTitle = "Invitations";
      this.noDataText = "No active invitations yet";
      this.pageDescription = "This lists all sent invitations by ";
    } else if (this.activeName == "connected") {
      this.activeValue = 2;
      this.pageTitle = "Appointments";
      this.noDataText = "No active appointments yet";
      this.pageDescription = "This lists all confirmed appointments to ";
    } else {
      this.activeValue = 4;
      this.pageTitle = "Job Offers";
      this.noDataText = "No active offers yet";
      this.pageDescription = "This lists all offers made by ";
    }
    this.loadData();
    //TODO: Reevaluate code below
    // this.initializeSignalR();
  },
  data() {
    return {
      tableData: [],
      search: "",
      activeName: "",
      pageTitle: "",
      showNoData: false,
      noDataText: "",
      pageDescription: "",
      activeValue: 0,
      isLoading: false,
      selectedRow: {},
      showAcceptModal: false,
      connection: "",
      huburl: "",
      showDeclineConnectModal: false,
      showRoleInfoModal: false,
      showAcceptApprenticeshipRoleModal: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;
      this.$store
        .dispatch("apprentice/getInterestedCompanies", {
          status: this.activeValue,
          userId: this.currentUser.id,
        })
        .then((res) => {
          this.tableData = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length === 0;
          this.isLoading = false;
        })
        .catch((res) => {
          this.showNoData = true;
          this.isLoading = false;
          this.$message.error(res.error);
        });
    },
    handleAccept(row) {
      this.selectedRow = row;
      this.showAcceptModal = true;
    },
    handleDeclineConnect(row) {
      this.selectedRow = row;
      this.showDeclineConnectModal = true;
    },
    handleView(row) {      
      this.selectedRow = {};
      this.selectedRow = row;
      this.showRoleInfoModal = true;
    },
    handleRoleInfoClosed() {
      this.showRoleInfoModal = false;
    },
    handleOffer(row) {
      this.selectedRow = row;
      this.showAcceptApprenticeshipRoleModal = true;
    },
    goBackToDashboard() {
      this.$router.push({ name: "InterestedCompaniesDashboard" });
    },
    //TODO: Reevaluate code below
    // initializeSignalR() {
    //   //create signalR connection
    //   this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
    //   this.connection = new signalR.HubConnectionBuilder()
    //     .withUrl(this.huburl, {
    //       transport:
    //         signalR.HttpTransportType.WebSockets |
    //         signalR.HttpTransportType.LongPolling,
    //       "content-type": "application/json",
    //       accessTokenFactory: () => localStorage.getItem("token"),
    //     })
    //     .build();

    //   this.connection.start().catch(function (err) {
    //     return console.error(err.toString());
    //   });
    // },
    acceptJobMatch() {
      this.isLoading = true;

      this.$store
        .dispatch(
          "apprentice/acceptCompanyInvitationToConnect",
          this.selectedRow
        )
        .then((res) => {
          this.isLoading = false;
          this.$message.success("Invitation accepted!");

          this.tableData = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length === 0;
          this.onCloseAcceptDialog();

          this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function (err) {
            return console.error(err.toString());
          });
        })
        .catch((res) => {
          this.isLoading = false;
          this.$message.error(res.error);
        });
    },
    onCloseAcceptDialog() {
      this.showAcceptModal = false;
      this.selectedRow = {};
    },
    declineConnect() {
      this.isLoading = true;
      this.$store
        .dispatch(
          "apprentice/declineCompanyInvitationToConnect",
          this.selectedRow
        )
        .then((res) => {
          this.tableData = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length === 0;
          this.onCloseDeclineConnectDialog();
          this.isLoading = false;
          this.$message.success("Connection to company declined!");
        })
        .catch((res) => {
          this.isLoading = false;
          this.$message.error(res.error);
        });
    },
    onCloseDeclineConnectDialog() {
      this.showDeclineConnectModal = false;
      this.selectedRow = {};
    },
    handleCancelJobMatchSuccess(data) {
      // this.tableData = data.requestBoardItems;
      // this.showNoData = data.requestBoardItems.length === 0;
      this.showRoleInfoModal = false;
      this.loadData();
      this.$message.success("Apprenticeship role match successfully cancelled");
    },
    handleAcceptJobOfferModalClosed() {
      this.showAcceptApprenticeshipRoleModal = false;
      this.selectedRow = {};
    },
    handleAcceptOfferSuccess(data) {
      this.tableData = data.requestBoardItems;
      this.showNoData = data.requestBoardItems.length === 0;
      this.showAcceptApprenticeshipRoleModal = false;
      this.$message.success(
        "Congratulations! You have successfully accepted the apprenticeship offer."
      );
      this.selectedRow = {};
    },
    handleDeclineOfferSuccess(data) {
      this.tableData = data.requestBoardItems;
      this.showNoData = data.requestBoardItems.length === 0;
      this.showAcceptApprenticeshipRoleModal = false;
      this.$message.success("You have declined the job offer.");
      this.selectedRow = {};
    },
  },
};
</script>

<style scoped>
.btn-decline {
  background-color: #14223c;
  color: white;
}
</style>
